import { render, staticRenderFns } from "./DocumentoaduaneroGrid.vue?vue&type=template&id=ec11d78c"
import script from "./DocumentoaduaneroGrid.vue?vue&type=script&lang=js"
export * from "./DocumentoaduaneroGrid.vue?vue&type=script&lang=js"
import style0 from "./DocumentoaduaneroGrid.vue?vue&type=style&index=0&id=ec11d78c&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports